import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollReveal = () => {
  const location = useLocation();

  useEffect(() => {
    const observed = new WeakSet();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          } else {
            entry.target.classList.remove("is-visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -60px 0px" }
    );

    const observeAll = () => {
      document.querySelectorAll(".reveal-up").forEach((el) => {
        if (!observed.has(el)) {
          observed.add(el);
          observer.observe(el);
        }
      });
    };

    // Initial pass after mount
    const t = setTimeout(observeAll, 50);

    // Re-observe whenever new .reveal-up elements are added (e.g. when
    // a tab swaps its content). MutationObserver watches for DOM changes
    // and re-scans for any missing observers.
    const mutationObserver = new MutationObserver(() => observeAll());
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      clearTimeout(t);
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, [location.pathname]);
};
